import React, { Suspense, useEffect } from 'react';
import { Routes, Route, useLocation } from "react-router-dom";

//Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";

//routes
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import { AuthProtected } from './AuthProtected';
import AdminProtected from './AdminProtected';
import useActivityTracker from '../Components/Hooks/useActivityTracker';

// Google Analytics page-view tracking for SPA route changes
function useGoogleAnalytics() {
    const location = useLocation();
    useEffect(() => {
        if (typeof window.gtag === 'function') {
            window.gtag('event', 'page_view', {
                page_path: location.pathname + location.search,
                page_location: window.location.href,
            });
        }
    }, [location]);
}

const Index = () => {
    useGoogleAnalytics();
    useActivityTracker();
    return (
        <React.Fragment>
            <Suspense fallback={<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}><div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading...</span></div></div>}>
            <Routes>
                <Route>
                    {publicRoutes.map((route, idx) => (
                        <Route
                            path={route.path}
                            element={
                                <NonAuthLayout>
                                    {route.component}
                                </NonAuthLayout>
                            }
                            key={idx}
                            exact={true}
                        />
                    ))}
                </Route>

                <Route>
                    {authProtectedRoutes.map((route, idx) => {
                        // Check if route is admin route
                        const isAdminRoute = route.path.startsWith('/admin');
                        
                        return (
                            <Route
                                path={route.path}
                                element={
                                    <AuthProtected>
                                        {isAdminRoute ? (
                                            <AdminProtected>
                                                <VerticalLayout>{route.component}</VerticalLayout>
                                            </AdminProtected>
                                        ) : (
                                            <VerticalLayout>{route.component}</VerticalLayout>
                                        )}
                                    </AuthProtected>
                                }
                                key={idx}
                                exact={true}
                            />
                        );
                    })}
                </Route>
            </Routes>
            </Suspense>
        </React.Fragment>
    );
};

export default Index;